var n=(r,t)=>{if(r)return t?`${r}-${t}`:r};export{n as getTestId};